import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const OpenInnerComponent = React.lazy(() => import("../Components/RootComponents/OpenInnerComponent"));
const OpenInnerPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <OpenInnerComponent />
      </Suspense>
    </Fragment>
  );
};

export default OpenInnerPage;
